<app-top-menu></app-top-menu>

<div class="container mt-5 mb-5">

    <div class="bg-white">

        <div class="reports-heading mb-3 mt-2 px-3 pt-2">
            <div class="ms-1 top-bar-div">
                <div class="mt-2">
                    <h6>MY ASSESSMENT BILLS</h6>
                </div>
            </div>
            <div class="right-buttons mt-2">
                <button class="custom-search-button" (click)="toggleSearch()">
                    Search
                    <span class="mdi mdi-magnify custom-search-icon"></span>
                </button>
            </div>
        </div>

        <!-- Search Panel -->
        <div class="search-parameters" *ngIf="showSearch">
            <form class="search-form" [formGroup]="searchForm">
                <button class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0"
                    (click)="toggleSearch()">
                    <span class="mdi mdi-close"></span>
                </button>
                <div class="row mt-2 mb-3">

                    <div class="col-md-5 mt-2">
                        <label>ASIN <span class="text-danger">*</span></label>
                        <input type="text" class="form-control small-option-font" placeholder="Enter your ASIN"
                            formControlName="asin" />
                        <div *ngIf="searchForm.get('asin')!.invalid && searchForm.get('asin')!.touched">
                            <small class="text-danger">ASIN is required.</small>
                        </div>
                    </div>

                    <div class="col-md-5 mt-2">
                        <label>Assessment Type</label>
                        <select class="form-control small-option-font" formControlName="assessmentType">
                            <option value="">-- All Types --</option>
                            <option *ngFor="let type of assessmentTypes" [value]="type.value">{{ type.label }}</option>
                        </select>
                    </div>

                    <div class="col-md-3 mt-3">
                        <button class="btn btn-sm search-button small-option-font"
                            [disabled]="!searchForm.get('asin')!.value"
                            (click)="search(); toggleSearch()" type="button">
                            Search
                        </button>
                    </div>
                    <div class="col-md-3 mt-3">
                        <button class="btn btn-sm reset-button small-option-font" (click)="resetForm()" type="button">
                            Reset
                        </button>
                    </div>

                </div>
            </form>
        </div>

        <!-- Results Table -->
        <div class="table-responsive mt-2">
            <table class="table table-striped table-hover table-bordered">
                <thead class="table-dark">
                    <tr>
                        <th class="assess-table-head">S/N</th>
                        <th class="assess-table-head">Assessment ID</th>
                        <th class="assess-table-head">Name</th>
                        <th class="assess-table-head">ASIN</th>
                        <th class="assess-table-head">Assessment Type</th>
                        <th class="assess-table-head">Assessment Year</th>
                        <th class="assess-table-head">Amount</th>
                        <th class="assess-table-head">Date Created</th>
                        <th class="assess-table-head">Approval Status</th>
                        <th class="assess-table-head">Payment Status</th>
                    </tr>
                </thead>
                <tbody *ngIf="!isSearching && pagedDetails?.length > 0">
                    <tr *ngFor="let d of pagedDetails; let i = index">
                        <td><span class="badge bg-dark">{{ i + 1 + num }}</span></td>
                        <td>{{ d?.assessmentId ?? '--' }}</td>
                        <td>{{ d?.name | titlecase }}</td>
                        <td>{{ d?.asin | uppercase }}</td>
                        <td>{{ d?.assessmentType | uppercase | removeUnderscores }}</td>
                        <td>{{ d?.assesssmentYear ?? '--' }}</td>
                        <td>&#8358;{{ d?.amountPaid | number:'1.2-2' }}</td>
                        <td>{{ d?.createdAt | date }}</td>
                        <td>
                            <span *ngIf="d?.approvalStatus; else noApproval" class="badge"
                                [ngClass]="{
                                    'bg-success': d?.approvalStatus === 'APPROVED',
                                    'bg-warning text-dark': d?.approvalStatus === 'PENDING',
                                    'bg-secondary': d?.approvalStatus !== 'APPROVED' && d?.approvalStatus !== 'PENDING'
                                }">
                                {{ d?.approvalStatus | uppercase }}
                            </span>
                            <ng-template #noApproval><span class="text-muted">--</span></ng-template>
                        </td>
                        <td>
                            <span class="badge"
                                [ngClass]="{
                                    'bg-success': d?.paymentStatus === 'PAID',
                                    'bg-danger': d?.paymentStatus === 'NOT_PAID',
                                    'bg-warning text-dark': d?.paymentStatus === 'PENDING'
                                }">
                                {{ d?.paymentStatus | uppercase | removeUnderscores }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-center mt-2">
            <p *ngIf="isSearching" class="text-muted">Please wait...</p>
            <p *ngIf="!isSearching && isEmpty" class="text-danger">No bills found for the provided ASIN.</p>
            <p *ngIf="searchInstruction" class="text-muted">Enter your ASIN and click Search to view your assessment bills.</p>
        </div>

        <div class="pagination justify-content-end">
            <ngb-pagination *ngIf="!isSearching && details?.length > pageSize"
                class="d-flex justify-content-center my-3"
                [(page)]="currentPage"
                (pageChange)="callDb($event)"
                [maxSize]="5"
                [pageSize]="pageSize"
                [collectionSize]="count"
                [boundaryLinks]="true"
                [directionLinks]="true"
                [rotate]="true">
            </ngb-pagination>
        </div>

    </div>
</div>

<app-footer></app-footer>
